<template lang="pug">
    ul.coupon-list.no-style-list(v-dragscroll)
        li(v-for="coupon in coupons")
            Coupon(:coupon="coupon" :key="coupon.id" @close-popover="$emit('close-popover')")
</template>

<script>
import { usePosCartStore } from '@/stores';

import Coupon from './Coupon';

export default {
    name: 'CouponList',
    components: {
        Coupon
    },
    computed: {
        posCartStore() {
            return usePosCartStore();
        },
        appliedCoupons() {
            return this.posCartStore.coupons;
        },
        applicableCustomerCoupons() {
            return this.posCartStore.applicableCustomerCoupons;
        },
        coupons() {
            // get all applicable customer coupons
            // and add applied coupons

            let coupons = _.cloneDeep(this.applicableCustomerCoupons);

            if (this.appliedCoupons.length) {
                this.appliedCoupons.forEach(coupon => {
                    if (!coupons.find(el => el.id === coupon.id)) coupons.push(coupon);
                });
            }

            return _.sortBy(coupons, [
                (coupon) => coupon.position != null ? parseInt(coupon.position) : 0,
                (coupon) => parseInt(coupon.id),
            ]);
        }
    }
};
</script>

<style lang="sass" scoped>
ul.coupon-list
    display: flex
    flex-wrap: nowrap
    gap: 4px
    margin-top: 4px
    overflow-x: auto
</style>
